/*!
 * @monogrid/vue-boost v9.0.0-develop.5 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useBreakpoints as f, breakpointsTailwind as v, useDebounceFn as p } from "@vueuse/core";
import m from "mobile-detect";
import { ref as a, watch as w } from "vue";
const e = {
  mobile: a(!1),
  phone: a(!1),
  tablet: a(!1),
  android: a(!1),
  ios: a(!1),
  ipad: a(!1),
  iphone: a(!1),
  edge: a(!1),
  firefox: a(!1),
  ie11: a(!1),
  safari: a(!1),
  prerenderer: a(!1),
  desktop: a(!1)
}, h = (n) => {
  const { lg: l, md: r, sm: d, xl: u } = f(n || v), s = p(() => {
    const i = window.navigator.userAgent, o = new m(i), t = "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2 && i.match(/Mac/);
    e.mobile.value = !!o.mobile() || !!t, e.phone.value = !!o.phone(), e.tablet.value = !!o.tablet() || !!t, e.android.value = !!o.is("AndroidOS"), e.ios.value = !!o.is("iOS"), e.ipad.value = !!o.is("iPad") || !!t, e.iphone.value = !!o.is("iPhone"), e.edge.value = !!/Edge\/\d+/i.test(i), e.firefox.value = o.version("Gecko") > 1, e.ie11.value = !!/Trident.*rv:11\./i.test(i), e.safari.value = /Safari/.test(i) && /Apple Computer/.test(window.navigator.vendor), e.prerenderer.value = "__PRERENDER_INJECTED" in window && window.__PRERENDER_INJECTED !== void 0, e.desktop.value = !e.mobile.value && !e.tablet.value;
  }, 100);
  return w([l, r, d, u], s), s(), e;
};
export {
  h as default,
  h as usePlatform
};
